import classNames from "classnames";
import React from "react";

export function ModalContainer({
  header,
  bgColor = "tw:bg-black/50",
  children,
  onClose,
}: {
  header?: React.ReactNode;
  bgColor?: string;
  children: React.ReactNode;
  onClose?: () => void;
}) {
  React.useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);

  return (
    <div
      className={classNames(
        bgColor,
        "tw:fixed tw:inset-0 tw:z-[1000]",
        "tw:flex tw:justify-center tw:items-center",
        "tw:overflow-x-hidden tw:overflow-y-hidden tw:outline-none focus:tw:outline-none",
      )}
    >
      <div
        className="tw:flex tw:flex-col tw:justify-center tw:items-center tw:w-full tw:h-full"
        id="modal-wrapper"
        onClick={(e: any) => {
          if (e?.target?.id === "modal-wrapper") {
            if (onClose) onClose();
          }
          e.stopPropagation();
        }}
      >
        {header}

        {children}
      </div>
    </div>
  );
}
